import { env } from '../env';

/**
 * Simple GET request wrapper
 */
export default {
  fetch(url) {
    const Image = env().Image;
    new Image().src = url;
  },
};
